<template>
  <div class="resultados">
    <MsgErroFormularios v-if="erro && msgErros" :mensagens="msgErros" />
    <table>
      <thead>
        <tr>
          <th style="width: 10%;">Número</th>
          <th style="width: 45%;">Título</th>
          <th style="width: 18%;">Tipo</th>
          <th style="width: 15%;">Status</th>
          <th style="width: 12%;">Ações</th>
        </tr>
      </thead>
      <tbody>
        <template v-for="ocorrencia in ocorrenciasFormat">
          <tr :key="'linha-' + ocorrencia.id">
            <td data-label="Número"><span>{{ ocorrencia.id }}</span></td>
            <td data-label="Título"><span>{{ ocorrencia.titulo }}</span></td>
            <td data-label="Tipo"><span>{{ formatarTipo(ocorrencia.tipo) }}</span></td>
                          <td data-label="Status">
                            <v-select
                              class="status-select"
                              :value="ocorrencia.status"
                              :options="optionsStatus"
                              :reduce="(option) => option.value"
                              @input="(novoStatusValor) => abrirModalConfirmacaoStatus(ocorrencia, novoStatusValor)"
                              label="label"
                              placeholder="Selecione o status"
                              :clearable="false"
                              :searchable="false"
                              :selectable="option => isStatusSelectable(option, ocorrencia)"
                            />
                          </td>            <td data-label="Ações" class="coluna-acoes">
              <div class="coluna-acoes-tabela">
                <div class="icone-tabela">
                  <router-link :to="{ name: 'OcorrenciasShow', params: { id: ocorrencia.id } }">
                    <img src="../../assets/imagens/icon-view.svg" alt="Visualizar" title="Visualizar" />
                  </router-link>
                </div>
                <div class="icone-tabela">
                  <router-link
                    v-if="podeEditar(ocorrencia)"
                    :to="{ name: 'OcorrenciasEdit', params: { id: ocorrencia.id } }">
                    <img src="../../assets/imagens/icon-edit.svg" alt="Editar" title="Editar" />
                  </router-link>
                </div>
                <div class="icone-tabela">
                  <span v-if="podeExcluir(ocorrencia)" @click="opcoesExcluir(ocorrencia.id)">
                    <img src="../../assets/imagens/icon-delete-preto.svg" alt="Excluir" title="Excluir" />
                  </span>
                  <span v-else style="display: inline-block; width: 23px; height: 23px;"></span>
                </div>
              </div>
            </td>
          </tr>
          <tr v-if="modalExclusaoVisivel === ocorrencia.id" :key="'modal-tr-' + ocorrencia.id" class="linha-modal">
            <td colspan="5" class="celula-modal">
              <div class="modal-edit">
                <div class="modal-mask">
                  <div class="modal-container">
                    <div class="modal-header">
                      <h2>Deseja mesmo excluir a ocorrência?</h2>
                    </div>
                    <div class="modal-body">
                      <p>Dados da Ocorrência:</p>
                      <div class="dados">
                        <p><strong>Título:</strong><span>{{ ocorrencia.titulo }}</span></p>
                        <p><strong>Tipo:</strong><span>{{ formatarTipo(ocorrencia.tipo) }}</span></p>
                        <p><strong>Status:</strong><span>{{ formatarStatus(ocorrencia.status) }}</span></p>
                      </div>
                    </div>
                    <div class="modal-footer">
                      <button class="btn-confirmar-edicao" @click="excluirLinha(ocorrencia.id)">Sim</button>
                      <button class="btn-cancelar-edicao" @click="fecharModalExclusao">Não</button>
                    </div>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </template>
        <tr v-if="!ocorrenciasFormat.length" class="sem-resultados">
          <td colspan="5" class="texto-centralizado"><b>Nenhum Resultado Encontrado</b></td>
        </tr>
      </tbody>
    </table>


    <!-- Modal de Confirmação de Mudança de Status -->
    <div v-if="modalConfirmacaoStatusVisivel && ocorrenciaParaAtualizar" class="modal-edit" :key="'modal-status-' + (ocorrenciaParaAtualizar ? ocorrenciaParaAtualizar.id : 'new')">
      <div class="modal-mask">
        <div class="modal-container">
          <div class="modal-header">
            <h2>Deseja mesmo alterar o status da ocorrência?</h2>
          </div>
          <div class="modal-body">
            <p>Dados da Ocorrência:</p>
            <div class="dados" v-if="ocorrenciaParaAtualizar">
              <p><strong>Número:</strong><span>{{ ocorrenciaParaAtualizar.id }}</span></p>
              <p><strong>Título:</strong><span>{{ ocorrenciaParaAtualizar.titulo }}</span></p>
              <p><strong>Novo Status:</strong><span>{{ formatarStatus(novoStatusProposto) }}</span></p>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn-confirmar-edicao" @click="confirmarMudancaStatus">Sim</button>
            <button class="btn-cancelar-edicao" @click="cancelarMudancaStatus">Não</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { parseISO, format } from "date-fns";
import vSelect from "vue-select";
import MsgErroFormularios from "../MsgErroFormularios";
import OcorrenciaApi from "../../services/OcorrenciaApi";
import Auth from "../../services/Auth";


export default {
  name: "TabelaResultadosOcorrencias",
  props: {
    ocorrencias: Array,
    ocorrencia: Object,
    usuario_logado: Object
  },
  created() {
    this.OcorrenciaApi = new OcorrenciaApi();
    this.auth = new Auth();
  },
  components: {
    MsgErroFormularios,
    vSelect,
  },
  data() {
    return {      
      msgErros: {
        ocorrencia: '',
        default: '',
        auth: null
      },
      carregando: false, // Adicionado, pois é usado em excluirLinha e será em atualizarStatus
      modalExclusaoVisivel: null,
      // Variáveis para o novo modal de confirmação de status
      modalConfirmacaoStatusVisivel: false,
      ocorrenciaParaAtualizar: null,
      statusOriginal: null,
      novoStatusProposto: null,
      // As variáveis abaixo parecem não estar em uso no contexto atual e podem ser candidatas a remoção
      ocorrenciaSelecionada: null,
      mostrarPopUpConfirmacao: false,
      statusSelecionado: '',
      novoStatus: null,
      erro: false,
      optionsStatus: [
        { label: "Aberto", value: "aberto" },
        { label: "Em Andamento", value: "em_andamento" },
        { label: "Finalizado", value: "finalizado" }
      ],
      optionsTipo: [
        { label: "Sugestão", value: "melhoria" },
        { label: "Reporte de Erro", value: "erro" },
        { label: "Dúvida", value: "duvida" },
        { label: "Elogio", value: "elogio" },
        { label: "Reclamação", value: "reclamacao" }
      ]
    };
  },
  computed: {
    ocorrenciasFormat() {
      if (!this.ocorrencias || !this.ocorrencias.length) return [];
      return this.ocorrencias.map((v) => ({
        ...v,
        usuario_id: v.usuario_id || (v.usuario && v.usuario.id)
      }));
    }
  },
  methods: {
    opcoesExcluir(ocorrenciaId) {
      this.modalExclusaoVisivel = ocorrenciaId;
    },
    fecharModalExclusao() {
      this.modalExclusaoVisivel = null;
    },
    abrirModalConfirmacaoStatus(ocorrencia, novoStatus) {
      if (ocorrencia.status === novoStatus) {
        return;
      }

      this.ocorrenciaParaAtualizar = ocorrencia;
      this.statusOriginal = ocorrencia.status; // Status antes da tentativa de mudança
      this.novoStatusProposto = novoStatus;    // Novo status selecionado pelo usuário
      this.modalConfirmacaoStatusVisivel = true;
    },
    fecharModalConfirmacaoStatus() {
      this.modalConfirmacaoStatusVisivel = false;
      this.ocorrenciaParaAtualizar = null;
      this.statusOriginal = null;
      this.novoStatusProposto = null;
    },
    async confirmarMudancaStatus() {
      if (!this.ocorrenciaParaAtualizar || this.novoStatusProposto === null) {
        this.fecharModalConfirmacaoStatus();
        return;
      }
      const ocorrenciaAlvo = this.ocorrenciaParaAtualizar;
      // Atualiza o status na ocorrência da lista this.ocorrencias ANTES de chamar a API
      this.$set(ocorrenciaAlvo, 'status', this.novoStatusProposto);
      await this.atualizarStatus(ocorrenciaAlvo); // Passa a ocorrência com o status já atualizado
      this.fecharModalConfirmacaoStatus();
    },
    cancelarMudancaStatus() {
      this.fecharModalConfirmacaoStatus();
    },
    async excluirLinha(ocorrenciaId) {
      try {
        this.carregando = true;
        this.erro = false;

        if (this.OcorrenciaApi.cancelTokens.destroyOcorrencia) {
          this.OcorrenciaApi.cancelTokens.destroyOcorrencia.cancel();
        }

        await this.OcorrenciaApi.destroyOcorrencia(ocorrenciaId);

        // Remove do array local
        const index = this.ocorrencias.findIndex(o => o.id === ocorrenciaId);
        if (index !== -1) {
          this.ocorrencias.splice(index, 1);
        }

        this.modalExclusaoVisivel = null;
      } catch (err) {
        this.modalExclusaoVisivel = null;
        this.carregando = false;
        this.erro = true;

        if (err.response && err.response.status === 404) {
          this.msgErros.ocorrencia = "A ocorrência já foi removida ou não existe.";
        } else {
          this.msgErros.ocorrencia = "Erro ao excluir a ocorrência.";
        }

        console.error('Erro ao excluir ocorrência:', err);
      }
    },
    formatarData(value) {
      return value ? format(parseISO(value), "dd/MM/yyyy") : '';
    },
    formatarDataParaComparacao(value) {
      return new Date(value).getTime();
    },
    async atualizarStatus(ocorrencia) {
      // As variáveis que causaram o erro foram removidas daqui.
      // Vamos usar os valores diretamente onde são necessários.
      
      try {
        this.carregando = true;
        this.erro = false;
        this.msgErros.default = ""; // Limpa erros anteriores

        await this.OcorrenciaApi.updateOcorrencia(ocorrencia.id, { status: ocorrencia.status });
        // Atualizar ocorrência com os dados salvos do backend
        const atualizada = await this.OcorrenciaApi.getOcorrencia(ocorrencia.id);
        // Substitui a ocorrência na lista local
        const index = this.ocorrencias.findIndex(o => o.id === atualizada.id);
        if (index !== -1) {
          this.$set(this.ocorrencias, index, atualizada); // Garante reatividade
        }
        
        // Dispara o evento para o Menu saber da atualização
        this.$root.$emit('ocorrenciasAtualizadas');

      } catch (error) {
        this.erro = true;
        this.msgErros.default = "Erro ao atualizar status da ocorrência.";
        console.error('❌ Erro ao atualizar status:', error.response?.data || error);

        // Reverter a mudança visual na lista 'this.ocorrencias' se a API falhar
        // Usamos 'ocorrencia.id' e 'this.statusOriginal' diretamente aqui
        const index = this.ocorrencias.findIndex(o => o.id === ocorrencia.id);
        if (index !== -1 && this.statusOriginal !== null) {
          this.$set(this.ocorrencias[index], 'status', this.statusOriginal);
        }
      } finally {
        this.carregando = false;
      }
    },
    cancelarAtualizacao() {
      this.mostrarPopUpConfirmacao = false;
      this.$emit('cancelar-popup');
    },
    formatarStatus(valor) {
      switch (valor) {
        case 'aberto': return 'Aberto';
        case 'em_andamento': return 'Em Andamento';
        case 'finalizado': return 'Finalizado';
        default: return valor;
      }
    },
    formatarTipo(valor) {
      switch (valor) {
        case 'melhoria': return 'Sugestão';
        case 'erro': return 'Reporte de Erro';
        case 'duvida': return 'Dúvida';
        case 'elogio': return 'Elogio';
        case 'reclamacao': return 'Reclamação';
        default: return valor;
      }
    },
    isStatusSelectable(option, ocorrencia) {
      const statusAtual = ocorrencia.status;
      const opcaoAlvo = option.value;
      const temComentarios = ocorrencia.comments_count > 0;

      if (statusAtual === 'aberto') {
        return true;
      }
      if (statusAtual === 'em_andamento') {
        if (!temComentarios) {
          return true;
        } else {
          return opcaoAlvo !== 'aberto';
        }
      }

      if (statusAtual === 'finalizado') {
        if (opcaoAlvo === 'aberto') {
          return false;
        }
      }

      // Se nenhuma das regras acima se aplicou, permite a seleção.
      return true;
    },
    podeEditar(ocorrencia) {
      return ocorrencia.status === 'aberto' && Number(this.usuario_logado.id) === Number(ocorrencia.usuario_id);
    },
    podeExcluir(ocorrencia) {
      return this.podeEditar(ocorrencia);
    },
  },
};
</script>

<style lang="scss" scoped>
  .linha-selecionada {
    background-color: yellow;
  }

  @media screen and (min-width: "1066px") {
    .resultados {
      table {
        tbody {
          tr {
            td {
              padding: 1rem .7rem;
              vertical-align: middle;
              font-size: .9rem;
              text-align: center;
            }

            td:nth-child(1) {
              min-width: 9rem;
              padding: .9rem;
              text-align: left;          
            }

            td:nth-child(2) {
              text-align: left;
            }

            td:nth-child(3) {
              text-align: left;
            }

            td:nth-child(4) {
              text-align: left;
            }

            td:nth-child(5) {
              text-align: left;
              max-width: 50rem;
            }
          }

          .coluna-acoes-tabela {
            
            .icone-tabela {
              margin: 0 .05rem 0 .05rem;
            }
          }
        }
      }

      td {
        img {
          height: 1.5rem;
          margin: 0rem 0.5rem 0rem 0.5rem;
        }
      }

      .modal-edit {
        position: fixed;
        z-index: 1000;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.6);
        display: table;
        transition: opacity 0.3s ease;

        .modal-mask {
          border-radius: 1rem;
          position: relative;
          z-index: 1000;
          top: 20vh;
          width: calc(40vw - 10rem);
          height: auto;
          background-color: #f2f2f2;
          transition: opacity 0.3s ease;
          margin: 0 auto;
        }

        .modal-container {
          height: 100%;
          padding: .7rem;
          position: relative;
          overflow-y: auto;
          overflow-x: auto;
          font-family: "Montserrat-Medium";
          align-content: center;

          .modal-header {
            height: fit-content;
            width: fit-content;
            margin: .5rem auto .3rem auto;

            h2 {
              font-size: 1.3rem;
              font-weight: bold;
            }
          }

          .modal-body {
            border: 1px solid gray;
            border-radius: 1rem;
            text-align: -webkit-center;

            p {
              font-size: 1rem;
              font-weight: bold;
              margin-top: .3rem;
              margin-bottom: .5rem;
              margin-left: 1rem;
              color: #005516;
            }

            .dados {
              font-weight: bold;
              font-size: 1rem;
              text-align-last: left;
              margin: 0 1rem .5rem 1rem;

              span {
                font-weight: normal;
                font-size: .9rem;
                margin-left: .3rem;
              }
            }
          }

          .modal-footer {
            margin: .7rem auto 0rem auto;
            place-content: space-evenly;
            font-size: 1rem;

            .btn-confirmar-edicao {
              border: none;
              border-radius: .5rem;
              width: 30%;
              height: 2.2rem;
              background-color: #005516;
              color: #f2f2f2;
            }

            .btn-confirmar-edicao:hover {
              background-color: #005517c2;
            }

            .btn-cancelar-edicao {
              border: none;
              border-radius: .5rem;
              width: 30%;
              height: 2.2rem;
              background-color: #bd0000;
              color: #f2f2f2;
            }

            .btn-cancelar-edicao:hover {
              background-color: #bd0000c4;
            }
          }
        }
      }
    }
  }

  @media screen and (min-width: "570px") and (max-width: "1065px") {
    .resultados {
      .modal-edit {
        position: fixed;
        z-index: 1000;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.6);
        display: table;
        transition: opacity 0.3s ease;

        .modal-mask {
          border-radius: 1rem;
          position: relative;
          z-index: 1000;
          top: 20vh;
          width: calc(40vw - 10rem);
          height: auto;
          background-color: #f2f2f2;
          transition: opacity 0.3s ease;
          margin: 0 auto;
        }

        .modal-container {
          height: 100%;
          padding: .7rem;
          position: relative;
          overflow-y: auto;
          overflow-x: auto;
          font-family: "Montserrat-Medium";
          align-content: center;

          .modal-header {
            height: fit-content;
            width: fit-content;
            margin: .5rem auto .3rem auto;

            h2 {
              font-size: 1.3rem;
              font-weight: bold;
            }
          }

          .modal-body {
            border: 1px solid gray;
            border-radius: 1rem;
            text-align: -webkit-center;

            p {
              font-size: 1rem;
              font-weight: bold;
              margin-top: .3rem;
              margin-bottom: .5rem;
              margin-left: 1rem;
              color: #005516;
            }

            .dados {
              font-weight: bold;
              font-size: 1rem;
              text-align-last: left;
              margin: 0 1rem .5rem 1rem;

              span {
                font-weight: normal;
                font-size: .9rem;
                margin-left: .3rem;
              }
            }
          }

          .modal-footer {
            margin: .7rem auto 0rem auto;
            place-content: space-evenly;
            font-size: 1rem;

            .btn-confirmar-edicao {
              border: none;
              border-radius: .5rem;
              width: 30%;
              height: 2.2rem;
              background-color: #005516;
              color: #f2f2f2;
            }

            .btn-confirmar-edicao:hover {
              background-color: #005517c2;
            }

            .btn-cancelar-edicao {
              border: none;
              border-radius: .5rem;
              width: 30%;
              height: 2.2rem;
              background-color: #bd0000;
              color: #f2f2f2;
            }

            .btn-cancelar-edicao:hover {
              background-color: #bd0000c4;
            }
          }
        }
      }
    }
  }

  @media screen and (min-width: "60px") and (max-width: "569px") {
    .resultados {
      .modal-edit {
        position: fixed;
        z-index: 1000;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.6);
        display: table;
        transition: opacity 0.3s ease;

        .modal-mask {
          border-radius: 1rem;
          position: relative;
          z-index: 1000;
          top: 20vh;
          width: calc(40vw - 10rem);
          height: auto;
          background-color: #f2f2f2;
          transition: opacity 0.3s ease;
          margin: 0 auto;
        }

        .modal-container {
          height: 100%;
          padding: .7rem;
          position: relative;
          overflow-y: auto;
          overflow-x: auto;
          font-family: "Montserrat-Medium";
          align-content: center;

          .modal-header {
            height: fit-content;
            width: fit-content;
            margin: .5rem auto .3rem auto;

            h2 {
              font-size: 1.3rem;
              font-weight: bold;
            }
          }

          .modal-body {
            border: 1px solid gray;
            border-radius: 1rem;
            text-align: -webkit-center;

            p {
              font-size: 1rem;
              font-weight: bold;
              margin-top: .3rem;
              margin-bottom: .5rem;
              margin-left: 1rem;
              color: #005516;
            }

            .dados {
              font-weight: bold;
              font-size: 1rem;
              text-align-last: left;
              margin: 0 1rem .5rem 1rem;

              span {
                font-weight: normal;
                font-size: .9rem;
                margin-left: .3rem;
              }
            }
          }

          .modal-footer {
            margin: .7rem auto 0rem auto;
            place-content: space-evenly;
            font-size: 1rem;

            .btn-confirmar-edicao {
              border: none;
              border-radius: .5rem;
              width: 30%;
              height: 2.2rem;
              background-color: #005516;
              color: #f2f2f2;
            }

            .btn-confirmar-edicao:hover {
              background-color: #005517c2;
            }

            .btn-cancelar-edicao {
              border: none;
              border-radius: .5rem;
              width: 30%;
              height: 2.2rem;
              background-color: #bd0000;
              color: #f2f2f2;
            }

            .btn-cancelar-edicao:hover {
              background-color: #bd0000c4;
            }
          }
        }
      }
    }
  }

  @media screen and (max-width: 1065px) {
    .status-select {
      display: block; /* Garante que o v-select ocupe a largura total disponível */
      width: auto;
      max-width: 200px;
    }
  }

  .status-select::v-deep .vs__dropdown-toggle {
    min-height: 28px !important;
    height: 28px !important;
  }

  .status-select::v-deep .vs__selected {
    font-size: 0.8rem !important;
    line-height: 1.2 !important;
  }

  .status-select::v-deep .vs__search {
    font-size: 0.8rem !important;
  }

  .status-select::v-deep .vs__dropdown-menu {
    font-size: 0.8rem !important;
  }
</style>